import { Input } from '@/components/ui/input';

// E1 logística · datos opcionales del paquete; no cambian la tarifa ni el cobro actual.
export const LOGISTICS_FIELDS = [
  { key: 'weight_kg', label: 'Peso (kg)', step: '0.01' },
  { key: 'length_cm', label: 'Largo (cm)', step: '0.1' },
  { key: 'width_cm', label: 'Ancho (cm)', step: '0.1' },
  { key: 'height_cm', label: 'Alto (cm)', step: '0.1' },
  { key: 'declared_value', label: 'Valor declarado (COP)', step: '1' },
];

export const logisticsFromProduct = (p) =>
  Object.fromEntries(LOGISTICS_FIELDS.map(({ key }) => [key, p?.[key] != null ? String(p[key]) : '']));

export const logisticsPayload = (form) =>
  Object.fromEntries(LOGISTICS_FIELDS.map(({ key }) => {
    const n = parseFloat(form[key]);
    return [key, Number.isFinite(n) && n > 0 ? n : null];
  }));

export const ProductLogisticsFields = ({ form, setForm }) => (
  <div className="col-span-2" data-testid="seller-product-logistics">
    <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
      Paquete
    </label>
    <div className="mt-1 grid grid-cols-2 gap-2 sm:grid-cols-5">
      {LOGISTICS_FIELDS.map(({ key, label, step }) => (
        <div key={key}>
          <div className="text-[11px] text-slate-500">{label}</div>
          <Input type="number" min="0" step={step} value={form[key] ?? ''}
            onChange={(e) => setForm({ ...form, [key]: e.target.value })}
            className="rounded-none mt-1" data-testid={`seller-product-${key.replace('_', '-')}`} />
        </div>
      ))}
    </div>
    <p className="mt-1 text-[11px] text-slate-400">Obligatorio si AutoMarket gestiona tus envíos: se usa para cotizar y contratar la guía. Peso en kg y medidas en cm del paquete listo para enviar; valor declarado = valor asegurado.</p>
  </div>
);
